import { useEffect, useState } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Input, Table } from 'reactstrap';
import ReactFileReader from 'react-file-reader';
import RodinaSelection from './RodinaSelection';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import HandleFoto from './HandleFoto';
import URLEndPointBE from './URLEndPointBE';
import EscapeTxt from './EscapeTxt';
import DeEscapeTxt from './DeEscapeTxt';

function ModifFormPovrch(props: any) { //props.povrch
    const { keycloak, initialized } = useKeycloak();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    //
    const pouziti = useSelector((state: any) => state.miscDicts.pouziti);
    //console.log("ModifTable props.edit- T: "+typeof(props.edit)+" / val: "+props.edit)
    
    ////// -BEGIN- POVRCHY
    const [formId, setFormId] = useState(null); //sent with UpdatePovrch, BE stamped id on AddPovrch
    const [formKod, setFormKod] = useState("");
    const [formKlasifikace, setFormKlasifikace] = useState(""); //NOT IN USE
    const [formNazev, setFormNazev] = useState("");
    const [formPopis, setFormPopis] = useState("");
    const [formNaslapnavrstvaV, setFormNaslapnavrstvaV] = useState(""); //AS naslapnavrstva_v
    const [formFormat, setFormFormat] = useState("");
    const [formPodminkaObecna, setFormPodminkaObecna] = useState(""); //AS podminka_obecna
    const [formKlad, setFormKlad] = useState("");
    const [formPoznamka, setFormPoznamka] = useState("");
    const [formModifikace, setFormModifikace] = useState("");
    const [formDostupnost, setFormDostupnost] = useState("");
    const [formCenovaHladina, setFormCenovaHladina] = useState("");
    const [formViditelnost, setFormViditelnost] = useState(99);
    const [formPouziti, setFormPouziti] = useState("");
    const [formStromy, setFormStromy] = useState(""); //NOT IN USE
    //// POVRCHY_POUZITI 6x
    const [formPovrchyPouziti, setFormPovrchyPouziti] = useState([{rodina_kod: null, pouziti_id: 99, podminka: ""}]);
    let handleFormPovrchyPouzitiChanged = (rod: any, pouz: any) => 
    {
        //console.log("handleFormPovrchyPouzitiChanged("+rod+"/"+pouz+")")
        let formPouziti_sliced = formPovrchyPouziti.slice();
        let _formPouziti = formPouziti_sliced.map((x: any) => (x.rodina_kod==rod?{...x, pouziti_id: pouz}: x));
        setFormPovrchyPouziti(_formPouziti);
    }
    let handleFormPovrchyPouzitiTxtChanged = (rod: any, podm: any) =>
    {
        //console.log("handleFormPovrchyTxtChanged("+rod+"/"+podm+")")
        let formPouziti_sliced = formPovrchyPouziti.slice();
        let _formPouziti = formPouziti_sliced.map((x: any) => (x.rodina_kod==rod?{...x, podminka: podm}: x));
        setFormPovrchyPouziti(_formPouziti);
    }
    //FOTO handling
    /*
    const [foto, setFoto] = useState([{fotoId: ""}, {fotoId: ""}]);
    //// FOTO 1,2
    const [formFotografie1, setFormFotografie1] = useState("");
    const [formFotografie1t, setFormFotografie1t] = useState("");
    const [formFotografie2, setFormFotografie2] = useState("");
    const [formFotografie2t, setFormFotografie2t] = useState("");
    let handleFile = (num: any, e: any) => {
        console.log(num);
        let file = e.fileList[0]; //name, type
        console.log(e.base64);
        switch (num) {
            case 1:
                setFormFotografie1(e.base64);
                setFormFotografie1t(file.type);
                break;
            case 2:
                setFormFotografie2(e.base64);
                setFormFotografie2t(file.type);
                break;
            default:
                console.log("err num foto edit");
                break;    
        }
    }
    */
    //FOTO NEW !2 now, state: WAITING, INSERT, DELETE
    const [formFotky, setFormFotky] = useState([{id: "", state: "WAITING", type: "", base64: ""}, {id: "", state: "WAITING", type: "", base64: ""}])
    let handlePridatFoto = (i: any, e: any) =>
    {
        let fotky = formFotky.slice();
        //e.base64 size - if larger then popup (file too big)
        let file = e.fileList[0]; //name, type
        let handled_fotka = fotky[i];   
            handled_fotka.state = "INSERT";
            handled_fotka.type = file.type;
            handled_fotka.base64 = e.base64;
        setFormFotky(fotky);  
        console.log("formFotky");
        console.log(formFotky);
    }
    let handleSmazatFoto = (i: any) => {
        let fotky = formFotky.slice();
        let handled_fotka = fotky[i];
            handled_fotka.state = "DELETE";
            handled_fotka.base64 = "";
        setFormFotky(fotky);
        console.log("formFotky");
        console.log(formFotky);
    }
    //-END-
    
    //Add new Povrch funct.
    const AddPovrch = () => {
        console.log("AddPovrch() called from ModifFormPovrch")
        //        id vv - As NEXTVAL_POVRCH stamped on BE
        let _povr = {  kod: formKod, klasifikace: formKlasifikace, nazev: formNazev, popis: formPopis, naslapnavrstva_v: formNaslapnavrstvaV, format: formFormat, podminka_obecna: formPodminkaObecna, klad: formKlad, poznamka: formPoznamka, modifikace: formModifikace, dostupnost: formDostupnost, cenovahladina: formCenovaHladina, viditelnost: formViditelnost, pouziti: formPouziti, stromy: formStromy }

        //Wrapping obj+pouziti
        let povrch = { povrch: _povr, povrchy_pouziti: formPovrchyPouziti }
        console.log("povrch")
        console.log(povrch)

        let _succ = true;
        let id_povrch = 0;
        //@ts-ignore                                                                            vv - Possibly null
        axios.post(URLEndPointBE+`/new/povrch`, povrch, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
            .then(function(response) { 
                console.log("Povrch - Insert SUCC")
                console.log(response.data);
                id_povrch=response.data.info;
            })
            .then(() => {
                console.log("then")
                formFotky.forEach(function (foto, i)
                {
                    console.log("foreach")
                    if(foto.state=="INSERT") {
                        console.log("insert")
                        console.log(foto)
                        let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type, image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                        //@ts-ignore                                                                         vv - Possibly null
                        axios.post(URLEndPointBE+`/new/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                            .then(() => {
                                console.log("Foto"+(i+1)+" - Insert SUCC")
                            })
                            .catch(function(error) {
                                console.log(error);
                                _succ = false;
                            })
                    }
                });
            })
            .catch(function(error) {
                console.log(error);
                _succ = false;
            }) 
            console.log("redirecting")
            if(_succ) {
                console.log("navigating, _succ: true")
                setTimeout(function() {
                    navigate('/povrchy', {state: {succ: true, type: 'VLOZENI', item: 'POVRCHU'}});
                }, 1500);
            }  
    }

    //Update existing Povrch
    const UpdatePovrch = () => {
        console.log("UpdatePovrch() called from ModifFormPovrch")

        let updatePovr = { id: formId, kod: formKod, klasifikace: formKlasifikace, nazev: formNazev, popis: formPopis, naslapnavrstva_v: formNaslapnavrstvaV, format: formFormat, podminka_obecna: formPodminkaObecna, klad: formKlad, poznamka: formPoznamka, modifikace: formModifikace, dostupnost: formDostupnost, cenovahladina: formCenovaHladina, viditelnost: formViditelnost, pouziti: formPouziti, stromy: formStromy }

        let updatePovrch = { povrch: updatePovr, povrchy_pouziti: formPovrchyPouziti }
        
        console.log("updatePovrch")
        console.log(updatePovrch)
        console.log("response - /povrch/povId")
        let _succ = true;
        //@ts-ignore                                                                                     vv - Possibly null
        axios.put(URLEndPointBE+`/povrch/`+formId, updatePovrch, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
            .then(function(response) {
                console.log(response.data);
            })
            .then(() => {
                formFotky.forEach(function (foto, i)
                {
                    switch(foto.state) {
                        case 'INSERT':
                            //UPDATE FOTO/id (poradi=i+1)
                            if(foto.id!=="") {
                                let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type , image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                                //@ts-ignore                                                                           vv - Possibly null
                                axios.put(URLEndPointBE+`/update/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - Update SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                 })
                            //INSERT FOTO
                            } else {
                                let _foto = {id: null, poradi: (i+1), prvek_id: formId, prvek_kod: formKod, soubor:"Prv_00.jpg", typ: foto.type, image_base64: (foto.base64).replace("data:"+foto.type+";base64,","") };
                                //@ts-ignore                                                                         vv - Possibly null
                                axios.post(URLEndPointBE+`/new/foto`, _foto, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - Insert SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                })
                            }
                            break;
                        case 'DELETE':
                            //DELETE id
                            if(foto.id!=="") {
                                //@ts-ignore                                                                                vv - Possibly null
                                axios.delete(URLEndPointBE+`/delete/foto/`+foto.id, { headers: {"Authorization" : `bearer ${keycloak.token}`, 'Content-Type': 'application/json'}})
                                .then(() => {
                                    console.log("Foto"+(i+1)+" - DELETE SUCC")
                                })
                                .catch(function(error) {
                                    console.log(error);
                                    _succ = false;
                                })
                            }
                            break;
                        default:
                            console.log("default")
                            break;
                    }
                });
            })   
            .catch(function(error) {
                console.log(error);
                _succ=false;
            })
            console.log("redirecting")
            if(_succ) {
                console.log("navigating, _succ: true")
                setTimeout(function() {
                    navigate('/povrchy/povrch/'+formId, {state: {succ: true, type: 'EDITACE', item: 'POVRCHU'}});
                }, 1500);
            } 
    }

    useEffect(() => {
        dispatch(setMenuSelected("povrchy"));
        console.log("useEffect()")

        //Rodiny pro edit form - TODO pick from Redux later (don't refetch)
        axios.get(URLEndPointBE+`/dict-misc/rodiny-povrchu`)
            .then((response) => {
                //pick filled out fetched_prvek_pouziti[r.kod-pouziti] - this
                let _rodinyPouziti = response.data.reduce((listVals: any, r: any) => ([...listVals, {rodina_kod: r.kod, pouziti_id: 99, podminka: ""}]), [])
                let _rodinyPouziti2 = _rodinyPouziti.slice()
                //If opened with EDIT=true
                if(props.edit) {
                    for(let cond of props.povrch.povrchyPouziti) {
                        //cond {rodina_kod, pouziti_id} for form
                        _rodinyPouziti2 = _rodinyPouziti2.map((x: any) => (x.rodina_kod==cond.rodina_kod?{...x, pouziti_id: cond.pouziti_id, podminka: cond.podminka}: x))
                    }
                }
                console.log(_rodinyPouziti2)
                setFormPovrchyPouziti(_rodinyPouziti2)
            })
            .catch((error) => {
                console.log("Err", error)
            })

        if(props.edit) {
            console.log("props.povrch dump")
            console.log(props.povrch)

            setFormId(props.povrch.id)
            setFormKod(DeEscapeTxt(props.povrch.kod))
            setFormNazev(DeEscapeTxt(props.povrch.nazev))
            let fotky = props.povrch.foto?.reduce((listFotky: any, fotka: any) => ([...listFotky, {id: fotka.fotoId, state:"VIEWING", type: null, base64: null}]), [])
            let fotky2 = [];
            //HOTFIX when foto: null
            if(props.povrch.foto!==null) {
                for(let i = 0; i < 2; ++i) {
                    if(fotky[i]!==undefined) {
                     fotky2[i] = fotky[i]
                 } else {
                        fotky2[i] = {id: "", state: "WAITING", type: "", base64: ""};
                    }
                }
            } else {
                fotky2[0] = {id: "", state: "WAITING", type: "", base64: ""};  
                fotky2[1] = {id: "", state: "WAITING", type: "", base64: ""};  
            }
            setFormFotky(fotky2)
            console.log("fotky2")
            console.log(fotky2)
            setFormViditelnost(props.povrch.viditelnost)
            setFormPodminkaObecna(DeEscapeTxt(props.povrch.podminkaobecna))
            setFormPopis(DeEscapeTxt(props.povrch.popis))
            setFormNaslapnavrstvaV(DeEscapeTxt(props.povrch.naslapnavrstva_v))
            setFormFormat(DeEscapeTxt(props.povrch.format))
            setFormPouziti(DeEscapeTxt(props.povrch.pouziti))
            setFormKlad(DeEscapeTxt(props.povrch.klad))
            setFormPoznamka(DeEscapeTxt(props.povrch.poznamka))
            setFormModifikace(DeEscapeTxt(props.povrch.modifikace))
            setFormDostupnost(DeEscapeTxt(props.povrch.dostupnost))
            setFormCenovaHladina(DeEscapeTxt(props.povrch.cenovahladina))
        }
    }, [])
    return (<Container>
        <div>
            <Table hover>
                <thead>
                    <tr>
                        <th className='justWrap'><span className="katBtnStyle ptHover" onClick={() => {navigate(-1)}} > &lt; ZPĚT </span></th>
                        <th>POVRCH</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className='justWrap'>KOD</th>
                        <td>
                            <Input
                                type="textarea"
                                //value={formKod}
                                value={(formKod)? formKod : ""}
                                onChange={(e: any) => {setFormKod(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th className='justWrap'>NÁZEV</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formNazev) ? formNazev : ""}
                                onChange={(e: any) => {setFormNazev(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VZOREK</th>
                        <td>
                            <div className={'wrapperFoto'}>
                                {formFotky.map( (foto: any, i) => <span>
                                    <HandleFoto i={i} foto={foto} handle_pridat_foto={handlePridatFoto} handle_smazat_foto={handleSmazatFoto}/>
                                </span> )}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VIDITELNOST</th>
                        <td>
                            <select onChange={(e: any) => {setFormViditelnost(e.target.value)}} value={formViditelnost}>
                                {viditelnost.map((vid: any) =>
                                    <option key={vid.key} value={vid.key}>{vid.value}</option>
                                )}
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POUŽITÍ</th>
                        <td className={"tableWrapCenter"}>
                            <table>
                                <tbody>
                                    {formPovrchyPouziti.map((rod: any) =>
                                    <tr key={rod.rodina_kod}>
                                        <td style={{textAlign: 'right'}}><span>{rod.rodina_kod}&nbsp;</span></td>
                                        {/* pouziti={pouziti} is /mist-dict/pouziti list */}
                                        <td><RodinaSelection pouziti={pouziti} sel_rod={rod.rodina_kod} sel_pouz={rod.pouziti_id} propagate_up_ref={handleFormPovrchyPouzitiChanged}/></td>
                                        {/*<td>
                                            <Input
                                                className={'filterInputStyle'}
                                                value={rod.podminka}
                                                placeholder="Dodatecna specif. pouziti..."
                                                onChange={(e: any) => {handleFormPovrchyPouzitiTxtChanged(rod.rodina_kod, e.target.value)}}
                                            />
                                        </td>*/}
                                    </tr>)}
                                    
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>PODMÍNKA</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formPodminkaObecna) ? formPodminkaObecna : ""}
                                onChange={(e: any) => {setFormPodminkaObecna(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POPIS</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formPopis) ? formPopis : ""}
                                onChange={(e: any) => {setFormPopis(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>VÝŠKA NÁŠLAPNÉ VRSTVY</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formNaslapnavrstvaV) ? formNaslapnavrstvaV : ""}
                                onChange={(e: any) => {setFormNaslapnavrstvaV(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>ZÁKLADNÍ (povolené) FORMÁTY</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formFormat) ? formFormat : ""}
                                onChange={(e: any) => {setFormFormat(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POUŽITÍ</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formPouziti) ? formPouziti : ""}
                                onChange={(e: any) => {setFormPouziti(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>KLAD</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formKlad) ? formKlad : ""}
                                onChange={(e: any) => {setFormKlad(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>POZNÁMKA (/Y)</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formPoznamka) ? formPoznamka : ""}
                                onChange={(e: any) => {setFormPoznamka(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>MODIFIKACE  (/VARIACE)</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formModifikace) ? formModifikace : ""}
                                onChange={(e: any) => {setFormModifikace(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>DOSTUPNOST</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formDostupnost) ? formDostupnost : ""}
                                onChange={(e: any) => {setFormDostupnost(e.target.value)}}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th scope="row" className='justWrap'>CENOVÁ HLADINA KRYTU (SOUVRSTVÍ)</th>
                        <td>
                            <Input
                                type="textarea"
                                value={(formCenovaHladina) ? formCenovaHladina : ""}
                                onChange={(e: any) => {setFormCenovaHladina(e.target.value)}}
                            />
                        </td>
                    </tr>
                </tbody>
            </Table>
            { (props.edit)
              ? <span className="katBtnStyle ptHover" onClick={() => {UpdatePovrch()}}> AKTUALIZOVAT </span>
              : <span className="katBtnStyle ptHover" onClick={() => {AddPovrch()}}> PŘIDAT </span>}
            <span>&nbsp;</span>
            <p>&nbsp;</p>
        </div>
    </Container>)
}
export default ModifFormPovrch